import store from 'app/store';

export default id => {
  const operations = store.get().getState().operation;
  return operations.indexOf(id) > -1;
};
